import(/* webpackMode: "eager" */ "/tmp/build_3badebea/web/src/app/global-error.tsx")